export const COURSE_SYSTEM_POLICY = 'lms-system-policy';
export const COURSE_SYSTEM_RULES = 'lms-system-rules';
export const COURSE_SYSTEM_BANNER = 'lms-system-banner';
export const COURSE_SYSTEM_FILES = 'lms-system-files';
export const COURSE_SYSTEM_AUTH = 'lms-system-auth';
export const COURSE_SYSTEM_HOME = 'lms-system-home';
